import { createFileRoute, Outlet } from "@tanstack/react-router";

import { MaintenanceWindow } from "@/components/MaintenanceWindow";
import { useIsBroadcastV2UnderMaintenance } from "@/features/BroadcastV2/flag";

export const Route = createFileRoute("/_auth/dragon-tiles/$siteId/broadcastV2")(
  {
    component: RouteComponent,
  },
);

export function RouteComponent() {
  const isUnderMaintenance = useIsBroadcastV2UnderMaintenance();

  // Block every BroadcastV2 page behind a maintenance window when enabled.
  if (isUnderMaintenance) {
    return <MaintenanceWindow />;
  }

  return <Outlet />;
}
